<template>
	<v-dialog
		class="dialog"
		v-model="visible"
		:max-width="maxWidth"
		persistent
	>
		<v-alert
			class="mb-0"
			border="top"
			colored-border
			:color="color"
		>
			<div class="main-content">
				<div>
					<v-icon v-if="icon_name_title.length !== 0" :color="color" class="mr-2">
						{{ icon_name_title }}
					</v-icon>
				</div>
				<div>
					<div class="title-text">{{ title }}</div>
					<div class="content-text">{{ content }}</div>
					<v-row v-if="isMode" class="mt-2 mx-1">
						<v-radio-group
							style="margin-top: 0; padding-top: 0;"
							v-model="mode"
							dense
							mandatory
						>
							<v-radio
								:value="0"
								:color="color"
							>
								<template v-slot:label>
									<span class="content-text">
										This and following events
									</span>
								</template>
							</v-radio>
							<v-radio
								:value="1"
								:color="color"
							>
								<template v-slot:label>
									<span class="content-text">
										This event only
									</span>
								</template>
							</v-radio>
						</v-radio-group>
					</v-row>
				</div>
			</div>
			<div class="button mt-4">
				<v-btn class="text-capitalize" outlined color="rgba(25, 42, 62, 0.7)" @click="$emit('cancel')">
					{{ cancel }}
				</v-btn>
				<v-btn depressed  :color="color" class="ml-2 white--text text-capitalize" @click="$emit('ok', mode)">
					<v-icon v-if="icon_name_front.length !== 0" class="mr-2">{{icon_name_front}}</v-icon>
					{{ ok }}
					<v-icon v-if="icon_name_rear.length !== 0">{{icon_name_rear}}</v-icon>
				</v-btn>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
export default {
	name: 'DeleteComfirmDialog',
	props:{
		visible: {
			type: Boolean,
			default: false
		},
		color: {
			/*  info: blue, error: red, warning: yellow */
			type: String,
			default: 'info',
		},
		title: {
			type: String,
			default: '',
		},
		content: {
			type: String,
			default: ''
		},
		isMode: {
			type: Boolean,
			default: false
		},
		cancel: {
			type: String,
			default: 'Cancel'
		},
		ok: {
			type: String,
			default: 'Ok'
		},
		icon_name_title: {
			type: String,
			default: '',
		},
		icon_name_front: {
			type: String,
			default: '',
		},
		icon_name_rear: {
			type: String,
			default: '',
		},
		maxWidth: {
			type: Number,
			default: 400
		}
	},
	data() {
		return {
			mode: 0
		}
	}
}
</script>
<style lang="scss" scoped>
.dialog {
	padding: 20px;
}
.main-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.content-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
</style>